export default {
  dynamicFormQuestionList: (state) => {
    /*
     * Construct a form questions object to access form questions via vuexId
     * Easy access via templates that maintain a relationship between screens and questions via vuexIds
     */
    return state.form.questions.reduce((result, question) => {
      result[question.vuexId] = question; //eslint-disable-line
      return result;
    }, {});
  },

  getCurrentDynamicFormQuestion(state, getters) {
    return getters.dynamicFormQuestionList[state.screens[state.currentScreen - 1].questionVuexId];
  },

  dynamicFormHasLogic(state) {
    return !!state.form.questions.find((question) => {
      return question.has_flows || question.has_scores;
    });
  },

  currentDynamicFormScreen(state) {
    return state.screens[state.currentScreen - 1];
  },

  getStatementsFromForm(state) {
    return state.form.questions.filter((question) => question.type === 'statement');
  },

  getFormQuestionsWithoutStatements(state) {
    // Used in calculating question numbers - Statements do not have questions numbers
    return state.form.questions.filter((question) => question.type !== 'statement');
  },
};
